import { ProtoBaseModel, attr } from '@square/dashboard-data/utils/ember-model-stubs';
export default ProtoBaseModel.extend({
  authorizationCode: attr(String),
  pwcTransactionId: attr(String),
  readOnlyCashtag: attr(String),
  readOnlyBuyerFullName: attr(String)
});